import { NaverMap } from "../../map/NaverMap";

const RealEstateMap = (props) => {

  const setView = (x, y, zoom) => {
    window.localStorage.setItem("realestate.RealEstateMap.view", JSON.stringify({ x, y, zoom }));
  };

  const getView = () => {
    const viewStr = window.localStorage.getItem("realestate.RealEstateMap.view");
    if (!viewStr)
      return { center: null, zoom: 15 };

    const view = JSON.parse(viewStr);
    return { center: { latitude: view.y, longitude: view.x }, zoom: view.zoom };
  };

  return (<>
    <NaverMap
      {...props}
      default={props.default ? props.default : getView()}
      onIdle={(e, map) => {
        setView(map.center.x, map.center.y, map.zoom);
        props.onIdle && props.onIdle(map);
      }} />
  </>);
};

export { RealEstateMap };
